<template>
    <div class="card">
        <div class="card-header" style="background-color: #87CDD2;">
            <div class="row">
                <div class="col">{{ titulo }}</div>
                <div class="col-2">
                    <select name="caps_usuario" class="form-control" id="caps_usuario" v-model="capsUser"
                        @change="atualizarUsuario()" v-if="componente == 'caixinha' && usuario.nivel_acesso == 'adm'">
                        <option v-for="lista in $store.state.listaCaps" :key="lista.id" :value="lista.id">
                            {{ lista.nome }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="card-body">
            <slot name="conteudo"></slot>
        </div>
        <div class="card-footer">
            <slot name="rodape"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['titulo', 'componente', 'usuario'],
    data() {
        return {
            listaCaps: {},
            capsUser: this.usuario.caps_id
        } 
    },
    methods: {
        carregaListaCaps() {
            let url = 'https://contasmoradores.candido.org.br/api/v1/caps?apenas_nomes=id,nome'

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.get(url, config)
                .then(response => {
                    this.$store.state.listaCaps = response.data
                })
                .catch(error => {
                    console.error("Erro na requisição:", error);
                });
        },
        atualizarUsuario() {
            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('caps_id', this.capsUser)


            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/user/' + this.usuario.id, formData, config)
                .then(response => {
                    window.location.reload()
                })
                .catch(errors => {
                    window.location.reload()
                })
        },
    },
    mounted() {
        this.carregaListaCaps()
    }
}
</script>
